import { render, staticRenderFns } from "./aisle.vue?vue&type=template&id=150b1be5&"
import script from "./aisle.vue?vue&type=script&lang=ts&"
export * from "./aisle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports